{
  "$id": "pinball/v1/audio/phonemes",
  "version": 1,
  "copyright": "© 2026 Holmes Computer Consultants. All rights reserved. -- www.holmesconsultants.com",
  "about": [
    "The shared phoneme table of 07 §4. Both cores render the same voice from this file, which is",
    "why it is a contract and not a constant in one of them.",
    "",
    "Each entry is a target for a five-formant parallel synthesizer. 'formants' is F1..F5 as",
    "[centreHz, bandwidthHz]; 'gains' is their relative amplitude; 'voiced' and 'noise' are how",
    "much of the glottal pulse train and of the noise source the segment is made of, which is the",
    "source-filter model's whole vocabulary. A voiced fricative is not a third source — it is a",
    "segment with some of each.",
    "",
    "'glide' is a second formant target for a diphthong, reached across the segment. A diphthong",
    "is one phoneme with a moving tongue rather than two phonemes in a row, and writing it as two",
    "would put a 40 ms transition in the middle of a sound that has no boundary.",
    "",
    "'closureMs' and 'burstMs' belong to stops and affricates: a plosive is silence and then a",
    "release, and leaving the silence out is what makes synthetic speech sound like it is running",
    "the words together.",
    "",
    "The inventory is the full ARPAbet, not the subset the flagship machine happens to use. A",
    "machine author who writes 'sh' must get a sound and not silence — the same failure the",
    "format's SYNTH_NAMES comment describes, in the layer below it.",
    "",
    "Frequencies are for an adult male tract, which is the reference the voice profiles scale.",
    "Vowel formants follow the Peterson-Barney measurements; bandwidths follow Klatt's synthesizer."
  ],
  "reference": {
    "alphabet": "arpabet",
    "formantCount": 5,
    "transitionMs": 40,
    "note": "Centre frequencies are for the reference tract. A voice profile scales them."
  },
  "phonemes": {
    "iy": {
      "class": "vowel",
      "ms": 120,
      "voiced": 1,
      "noise": 0,
      "formants": [[270, 60], [2290, 100], [3010, 170], [3700, 220], [4500, 280]],
      "gains": [1, 0.5, 0.32, 0.14, 0.05]
    },
    "ih": {
      "class": "vowel",
      "ms": 95,
      "voiced": 1,
      "noise": 0,
      "formants": [[390, 65], [1990, 100], [2550, 150], [3400, 210], [4500, 280]],
      "gains": [1, 0.56, 0.26, 0.12, 0.05]
    },
    "eh": {
      "class": "vowel",
      "ms": 110,
      "voiced": 1,
      "noise": 0,
      "formants": [[530, 70], [1840, 100], [2480, 150], [3400, 210], [4500, 280]],
      "gains": [1, 0.6, 0.24, 0.11, 0.05]
    },
    "ae": {
      "class": "vowel",
      "ms": 135,
      "voiced": 1,
      "noise": 0,
      "formants": [[660, 80], [1720, 100], [2410, 150], [3300, 210], [4500, 280]],
      "gains": [1, 0.62, 0.22, 0.1, 0.05]
    },
    "aa": {
      "class": "vowel",
      "ms": 130,
      "voiced": 1,
      "noise": 0,
      "formants": [[730, 85], [1090, 95], [2440, 150], [3400, 210], [4500, 280]],
      "gains": [1, 0.66, 0.18, 0.09, 0.04]
    },
    "ao": {
      "class": "vowel",
      "ms": 130,
      "voiced": 1,
      "noise": 0,
      "formants": [[570, 75], [840, 95], [2410, 150], [3300, 210], [4500, 280]],
      "gains": [1, 0.7, 0.16, 0.08, 0.04]
    },
    "uh": {
      "class": "vowel",
      "ms": 90,
      "voiced": 1,
      "noise": 0,
      "formants": [[440, 70], [1020, 95], [2240, 150], [3300, 210], [4500, 280]],
      "gains": [1, 0.64, 0.18, 0.08, 0.04]
    },
    "uw": {
      "class": "vowel",
      "ms": 120,
      "voiced": 1,
      "noise": 0,
      "formants": [[300, 60], [870, 90], [2240, 150], [3200, 210], [4500, 280]],
      "gains": [1, 0.6, 0.14, 0.07, 0.03]
    },
    "ah": {
      "class": "vowel",
      "ms": 85,
      "voiced": 1,
      "noise": 0,
      "formants": [[640, 80], [1190, 95], [2390, 150], [3300, 210], [4500, 280]],
      "gains": [1, 0.64, 0.2, 0.09, 0.04]
    },
    "er": {
      "class": "vowel",
      "ms": 125,
      "voiced": 1,
      "noise": 0,
      "formants": [[490, 70], [1350, 95], [1690, 130], [3300, 210], [4500, 280]],
      "gains": [1, 0.7, 0.5, 0.09, 0.04]
    },
    "ey": {
      "class": "diphthong",
      "ms": 175,
      "voiced": 1,
      "noise": 0,
      "formants": [[530, 70], [1840, 100], [2480, 150], [3400, 210], [4500, 280]],
      "glide": [[350, 65], [2200, 100], [2900, 160], [3600, 210], [4500, 280]],
      "gains": [1, 0.6, 0.26, 0.11, 0.05]
    },
    "ay": {
      "class": "diphthong",
      "ms": 190,
      "voiced": 1,
      "noise": 0,
      "formants": [[730, 85], [1090, 95], [2440, 150], [3400, 210], [4500, 280]],
      "glide": [[350, 65], [2100, 100], [2800, 160], [3500, 210], [4500, 280]],
      "gains": [1, 0.62, 0.24, 0.1, 0.05]
    },
    "oy": {
      "class": "diphthong",
      "ms": 195,
      "voiced": 1,
      "noise": 0,
      "formants": [[570, 75], [840, 95], [2410, 150], [3300, 210], [4500, 280]],
      "glide": [[400, 65], [2000, 100], [2600, 160], [3400, 210], [4500, 280]],
      "gains": [1, 0.64, 0.22, 0.1, 0.05]
    },
    "aw": {
      "class": "diphthong",
      "ms": 190,
      "voiced": 1,
      "noise": 0,
      "formants": [[730, 85], [1090, 95], [2440, 150], [3400, 210], [4500, 280]],
      "glide": [[350, 65], [900, 90], [2300, 150], [3200, 210], [4500, 280]],
      "gains": [1, 0.66, 0.18, 0.09, 0.04]
    },
    "ow": {
      "class": "diphthong",
      "ms": 165,
      "voiced": 1,
      "noise": 0,
      "formants": [[490, 70], [910, 95], [2400, 150], [3300, 210], [4500, 280]],
      "glide": [[350, 65], [800, 90], [2300, 150], [3200, 210], [4500, 280]],
      "gains": [1, 0.66, 0.16, 0.08, 0.04]
    },
    "l": {
      "class": "liquid",
      "ms": 75,
      "voiced": 1,
      "noise": 0,
      "level": 0.51,
      "formants": [[360, 60], [1300, 90], [2700, 180], [3300, 240], [4500, 300]],
      "gains": [1, 0.34, 0.12, 0.06, 0.03]
    },
    "r": {
      "class": "liquid",
      "ms": 75,
      "voiced": 1,
      "noise": 0,
      "level": 0.45,
      "formants": [[310, 60], [1060, 90], [1380, 120], [3300, 240], [4500, 300]],
      "gains": [1, 0.62, 0.44, 0.06, 0.03]
    },
    "w": {
      "class": "glide",
      "ms": 65,
      "voiced": 1,
      "noise": 0,
      "level": 0.37,
      "formants": [[300, 60], [610, 90], [2200, 170], [3200, 240], [4500, 300]],
      "gains": [1, 0.56, 0.12, 0.06, 0.03]
    },
    "y": {
      "class": "glide",
      "ms": 60,
      "voiced": 1,
      "noise": 0,
      "level": 0.35,
      "formants": [[240, 55], [2280, 100], [3000, 170], [3600, 220], [4500, 280]],
      "gains": [1, 0.48, 0.28, 0.12, 0.05]
    },
    "m": {
      "class": "nasal",
      "ms": 75,
      "voiced": 1,
      "noise": 0,
      "level": 0.19,
      "formants": [[250, 70], [1100, 180], [2200, 300], [3200, 360], [4500, 400]],
      "gains": [1, 0.12, 0.05, 0.02, 0.01]
    },
    "n": {
      "class": "nasal",
      "ms": 70,
      "voiced": 1,
      "noise": 0,
      "level": 0.19,
      "formants": [[250, 70], [1700, 180], [2600, 300], [3400, 360], [4500, 400]],
      "gains": [1, 0.16, 0.07, 0.03, 0.01]
    },
    "ng": {
      "class": "nasal",
      "ms": 80,
      "voiced": 1,
      "noise": 0,
      "level": 0.18,
      "formants": [[250, 70], [2300, 200], [2900, 300], [3600, 360], [4500, 400]],
      "gains": [1, 0.2, 0.08, 0.03, 0.01]
    },
    "f": {
      "class": "fricative",
      "ms": 95,
      "voiced": 0,
      "noise": 1,
      "level": 0.022,
      "formants": [[1000, 400], [4500, 900], [7000, 1300], [8500, 1600], [9500, 2000]],
      "gains": [0.3, 0.7, 1, 0.8, 0.5]
    },
    "v": {
      "class": "fricative",
      "ms": 70,
      "voiced": 0.45,
      "noise": 0.55,
      "level": 0.068,
      "formants": [[300, 90], [1000, 400], [4500, 900], [7000, 1300], [8500, 1600]],
      "gains": [1, 0.3, 0.5, 0.55, 0.35]
    },
    "th": {
      "class": "fricative",
      "ms": 90,
      "voiced": 0,
      "noise": 1,
      "level": 0.021,
      "formants": [[1400, 500], [5500, 1000], [7500, 1400], [8800, 1700], [9800, 2000]],
      "gains": [0.35, 0.8, 1, 0.75, 0.45]
    },
    "dh": {
      "class": "fricative",
      "ms": 65,
      "voiced": 0.45,
      "noise": 0.55,
      "level": 0.066,
      "formants": [[300, 90], [1400, 500], [5500, 1000], [7500, 1400], [8800, 1700]],
      "gains": [1, 0.35, 0.55, 0.5, 0.3]
    },
    "s": {
      "class": "fricative",
      "ms": 120,
      "voiced": 0,
      "noise": 1,
      "level": 0.091,
      "formants": [[4000, 500], [6500, 700], [8000, 1000], [9500, 1300], [10500, 1600]],
      "gains": [0.5, 1, 0.9, 0.6, 0.35]
    },
    "z": {
      "class": "fricative",
      "ms": 95,
      "voiced": 0.45,
      "noise": 0.55,
      "level": 0.136,
      "formants": [[280, 90], [4000, 500], [6500, 700], [8000, 1000], [9500, 1300]],
      "gains": [1, 0.5, 0.9, 0.7, 0.4]
    },
    "sh": {
      "class": "fricative",
      "ms": 125,
      "voiced": 0,
      "noise": 1,
      "level": 0.116,
      "formants": [[2200, 350], [3200, 450], [4500, 700], [6000, 1000], [7500, 1300]],
      "gains": [0.8, 1, 0.9, 0.55, 0.3]
    },
    "zh": {
      "class": "fricative",
      "ms": 100,
      "voiced": 0.45,
      "noise": 0.55,
      "level": 0.145,
      "formants": [[280, 90], [2200, 350], [3200, 450], [4500, 700], [6000, 1000]],
      "gains": [1, 0.7, 0.9, 0.6, 0.35]
    },
    "hh": {
      "class": "aspirate",
      "ms": 60,
      "voiced": 0.08,
      "noise": 0.92,
      "level": 0.14,
      "formants": [[500, 180], [1500, 250], [2500, 350], [3400, 450], [4500, 550]],
      "gains": [1, 0.7, 0.4, 0.2, 0.1]
    },
    "p": {
      "class": "stop",
      "ms": 12,
      "closureMs": 55,
      "burstMs": 12,
      "voiced": 0,
      "noise": 1,
      "level": 0.169,
      "formants": [[800, 350], [1200, 450], [2000, 650], [3000, 850], [4000, 1000]],
      "gains": [1, 0.8, 0.5, 0.3, 0.15]
    },
    "b": {
      "class": "stop",
      "ms": 10,
      "closureMs": 40,
      "burstMs": 8,
      "voiced": 0.35,
      "noise": 0.65,
      "level": 0.274,
      "formants": [[300, 90], [800, 350], [1200, 450], [2000, 650], [3000, 850]],
      "gains": [1, 0.8, 0.6, 0.35, 0.18]
    },
    "t": {
      "class": "stop",
      "ms": 14,
      "closureMs": 55,
      "burstMs": 14,
      "voiced": 0,
      "noise": 1,
      "level": 0.147,
      "formants": [[3500, 450], [4500, 650], [5500, 850], [7000, 1100], [8000, 1300]],
      "gains": [0.8, 1, 0.9, 0.6, 0.35]
    },
    "d": {
      "class": "stop",
      "ms": 11,
      "closureMs": 40,
      "burstMs": 10,
      "voiced": 0.35,
      "noise": 0.65,
      "level": 0.235,
      "formants": [[300, 90], [3500, 450], [4500, 650], [5500, 850], [7000, 1100]],
      "gains": [1, 0.8, 0.85, 0.55, 0.3]
    },
    "k": {
      "class": "stop",
      "ms": 18,
      "closureMs": 60,
      "burstMs": 18,
      "voiced": 0,
      "noise": 1,
      "level": 0.207,
      "formants": [[1800, 320], [2200, 380], [3000, 550], [4000, 750], [5000, 950]],
      "gains": [1, 0.95, 0.7, 0.4, 0.2]
    },
    "g": {
      "class": "stop",
      "ms": 14,
      "closureMs": 45,
      "burstMs": 14,
      "voiced": 0.35,
      "noise": 0.65,
      "level": 0.217,
      "formants": [[300, 90], [1800, 320], [2200, 380], [3000, 550], [4000, 750]],
      "gains": [1, 0.9, 0.85, 0.5, 0.25]
    },
    "ch": {
      "class": "affricate",
      "ms": 85,
      "closureMs": 55,
      "burstMs": 85,
      "voiced": 0,
      "noise": 1,
      "level": 0.126,
      "formants": [[2200, 350], [3200, 450], [4500, 700], [6000, 1000], [7500, 1300]],
      "gains": [0.8, 1, 0.9, 0.55, 0.3]
    },
    "jh": {
      "class": "affricate",
      "ms": 75,
      "closureMs": 45,
      "burstMs": 75,
      "voiced": 0.4,
      "noise": 0.6,
      "level": 0.174,
      "formants": [[280, 90], [2200, 350], [3200, 450], [4500, 700], [6000, 1000]],
      "gains": [1, 0.7, 0.9, 0.6, 0.3]
    }
  }
}
